export const articlesScience = [
  {
    id: "science-1",
    title: "认识自慰：从科学角度看一件正常的事",
    summary:
      "自慰是人类普遍存在的正常行为。本文从生理学与心理学角度，带你客观认识它，并理解为什么它并不值得羞耻。",
    cover:
      "https://readdy.ai/api/search-image?query=soft%20abstract%20wellness%20illustration%20with%20gentle%20organic%20curves%20in%20teal%20and%20warm%20sand%20tones%2C%20calm%20minimal%20editorial%20style%20with%20generous%20negative%20space&width=800&height=600&seq=science-01&orientation=landscape",
    categoryId: "science",
    author: "编辑部",
    date: "2026-09-28",
    readCount: 8421,
    tags: ["科普", "认知"],
    sections: [
      {
        heading: "它其实非常普遍",
        paragraphs: [
          "无论性别、年龄或文化背景，自慰都是人类中极为常见的行为。多项调查显示，绝大多数成年人在一生中都曾有过这样的经历。",
          "普遍存在本身就说明，这是一种自然的生理现象，而不是需要被归类为异常的事情。",
        ],
      },
      {
        heading: "身体为什么会这样做",
        paragraphs: [
          "从生理角度看，身体会通过一系列神经与激素反应带来愉悦感与放松感，这有助于缓解紧张、改善睡眠，并帮助人更好地了解自己的身体。",
          "它并不依赖他人，是一种可以独立完成的自我调节方式。",
        ],
      },
      {
        heading: "为什么很多人仍感到不安",
        paragraphs: [
          "长期以来，信息匮乏与文化禁忌让许多人对这件事感到困惑甚至羞耻。这些感受更多来自后天观念，而非身体本身出了问题。",
          "用科学、平和的态度去了解，往往能帮助人卸下不必要的心理负担。",
        ],
      },
    ],
  },
  {
    id: "science-2",
    title: "自慰与身体健康：常见误区与科学事实",
    summary:
      "“自慰伤身体”“会导致肾虚”——这些说法有依据吗？我们逐一梳理流传最广的说法，并给出基于证据的解读。",
    cover:
      "https://readdy.ai/api/search-image?query=minimal%20wellness%20abstract%20composition%20with%20flowing%20teal%20shapes%20and%20soft%20amber%20accents%20on%20light%20cream%20background%2C%20editorial%20flat%20illustration&width=800&height=600&seq=science-02&orientation=landscape",
    categoryId: "science",
    author: "编辑部",
    date: "2026-09-25",
    readCount: 6230,
    tags: ["辟谣", "生理"],
    sections: [
      {
        heading: "“伤身体”的说法从哪来",
        paragraphs: [
          "许多流传的说法源自旧时代的观念与经验总结，并不符合现代医学对身体的了解。",
          "目前并没有可靠证据表明，适度的自慰会对身体健康造成损害。",
        ],
      },
      {
        heading: "需要留意的其实是什么",
        paragraphs: [
          "真正值得关注的是卫生习惯、动作是否过于剧烈，以及它是否影响到你的日常生活与情绪状态。",
          "把这些因素照顾好，比担心那些没有依据的说法更有意义。",
        ],
      },
      {
        heading: "用证据说话",
        paragraphs: [
          "面对各种健康信息，优先参考权威医学机构与同行评审研究，能帮你避开大量误导。",
        ],
      },
    ],
  },
  {
    id: "science-3",
    title: "自慰频率多少算正常？科学解读个体差异",
    summary:
      "有人每周几次，有人每月一次，还有人几乎不做——“正常”到底有没有标准？答案是，你的身体比你想象的更懂自己。",
    cover:
      "https://readdy.ai/api/search-image?query=calm%20abstract%20illustration%20of%20balanced%20organic%20forms%20in%20muted%20green%20teal%20and%20warm%20beige%20tones%2C%20soft%20wellness%20editorial%20aesthetic&width=800&height=600&seq=science-03&orientation=landscape",
    categoryId: "science",
    author: "编辑部",
    date: "2026-09-22",
    readCount: 7510,
    tags: ["频率", "科普"],
    sections: [
      {
        heading: "没有统一的标准",
        paragraphs: [
          "频率受年龄、激素水平、情绪状态、生活节奏和伴侣关系等多种因素影响，差异非常大。",
          "很难用一个固定数字去衡量所有人是否“正常”。",
        ],
      },
      {
        heading: "更值得问的问题",
        paragraphs: [
          "与其纠结次数，不如问问自己：它是否影响睡眠、工作、情绪和人际关系？",
          "如果答案是否定的，那么多数情况下你无需过度担心。",
        ],
      },
      {
        heading: "什么时候需要调整",
        paragraphs: [
          "当它开始占据大量时间、引发持续焦虑，或让你回避真实生活时，就是值得停下来关注的信号。",
        ],
      },
    ],
  },
  {
    id: "science-4",
    title: "自慰会影响生育能力吗？权威研究怎么说",
    summary:
      "这是很多人关心的问题。本文整理了相关研究与医学观点，帮助你区分“传说”和“事实”。",
    cover:
      "https://readdy.ai/api/search-image?query=soft%20scientific%20wellness%20abstract%20art%20with%20delicate%20teal%20lines%20and%20gentle%20orange%20highlights%20on%20a%20clean%20light%20background%2C%20minimal%20editorial&width=800&height=600&seq=science-04&orientation=landscape",
    categoryId: "science",
    author: "编辑部",
    date: "2026-09-19",
    readCount: 9880,
    tags: ["生育", "研究"],
    sections: [
      {
        heading: "两者之间没有直接因果",
        paragraphs: [
          "现有研究并未发现适度的自慰会损害生育能力。身体的生殖系统具有自我调节和恢复能力。",
          "把生育问题简单归因于这一行为，往往会掩盖真正需要关注的健康因素。",
        ],
      },
      {
        heading: "真正影响生育的因素",
        paragraphs: [
          "作息、饮食、压力、吸烟饮酒、某些疾病等，才是与生殖健康关系更密切的因素。",
          "如果长期备孕困难，寻求专业医生的帮助是更可靠的选择。",
        ],
      },
    ],
  },
  {
    id: "science-5",
    title: "关于自慰的10个常见谣言与真相",
    summary:
      "从“会导致失明”到“影响记忆”，各种说法层出不穷。我们挑选了传播最广的10条，逐条给出科学回应。",
    cover:
      "https://readdy.ai/api/search-image?query=playful%20minimal%20abstract%20illustration%20of%20overlapping%20rounded%20shapes%20in%20teal%20and%20soft%20terracotta%2C%20clean%20wellness%20magazine%20style&width=800&height=600&seq=science-05&orientation=landscape",
    categoryId: "science",
    author: "编辑部",
    date: "2026-09-16",
    readCount: 5670,
    tags: ["辟谣", "合集"],
    sections: [
      {
        heading: "谣言往往比科学传播得更快",
        paragraphs: [
          "夸张的说法更容易被记住，而严谨的解释往往显得平淡。这正是谣言长期存在的原因。",
        ],
      },
      {
        heading: "逐条看懂",
        paragraphs: [
          "绝大多数耸人听闻的说法，都缺乏可靠的研究支持。面对它们，保持好奇与求证的心态最重要。",
          "遇到不确定的健康信息，优先查阅权威机构发布的内容。",
        ],
      },
      {
        heading: "如何自己判断",
        paragraphs: [
          "问三个问题：来源是谁？有没有研究支持？结论是否过分绝对？这能帮你过滤掉大量噪音。",
        ],
      },
    ],
  },
  {
    id: "science-6",
    title: "自慰与荷尔蒙：身体内部的真实反应",
    summary:
      "多巴胺、催产素、内啡肽……这些名字听起来复杂，其实它们解释了为什么身体会感到放松与愉悦。",
    cover:
      "https://readdy.ai/api/search-image?query=abstract%20representation%20of%20gentle%20hormonal%20balance%20using%20soft%20layered%20teal%20and%20amber%20circles%2C%20calm%20scientific%20wellness%20editorial%20illustration&width=800&height=600&seq=science-06&orientation=landscape",
    categoryId: "science",
    author: "编辑部",
    date: "2026-09-13",
    readCount: 4390,
    tags: ["荷尔蒙", "生理"],
    sections: [
      {
        heading: "愉悦感来自哪里",
        paragraphs: [
          "身体在性反应过程中会释放多种神经递质与激素，它们共同带来愉悦、放松与满足的感受。",
          "这也是为什么很多人在之后会感到困倦或平静。",
        ],
      },
      {
        heading: "放松是有生理基础的",
        paragraphs: [
          "催产素与内啡肽等物质的释放，有助于缓解紧张感，让人感觉更安稳。",
          "理解这一点，有助于我们用平常心看待身体的自然反应。",
        ],
      },
    ],
  },
  {
    id: "science-7",
    title: "从生理机制理解性反应周期",
    summary:
      "身体在性反应中会经历几个阶段，了解这些阶段能帮助你更从容地认识自己的感受与节奏。",
    cover:
      "https://readdy.ai/api/search-image?query=flowing%20abstract%20wave%20illustration%20in%20green%20teal%20and%20warm%20cream%20tones%2C%20minimal%20scientific%20wellness%20poster%20style&width=800&height=600&seq=science-07&orientation=landscape",
    categoryId: "science",
    author: "编辑部",
    date: "2026-09-10",
    readCount: 3980,
    tags: ["生理", "科普"],
    sections: [
      {
        heading: "几个相连的阶段",
        paragraphs: [
          "一般来说，身体会经历唤起、平台、高潮与消退等阶段，但每个人的体验和节奏都不相同。",
          "没有必须达到的标准流程，感受本身比“阶段”更重要。",
        ],
      },
      {
        heading: "了解自己的节奏",
        paragraphs: [
          "认识身体在不同阶段的变化，有助于减少焦虑，也让自我照顾更有方向。",
        ],
      },
    ],
  },
  {
    id: "science-8",
    title: "自慰会“上瘾”吗？认识行为与依赖的区别",
    summary:
      "“上瘾”是一个被频繁使用的词，但在医学上它有明确的含义。本文帮你区分习惯、依赖与真正需要关注的情况。",
    cover:
      "https://readdy.ai/api/search-image?query=calm%20conceptual%20illustration%20of%20a%20gentle%20loop%20of%20teal%20ribbons%20with%20soft%20orange%20knot%2C%20minimal%20wellness%20editorial%20background&width=800&height=600&seq=science-08&orientation=landscape",
    categoryId: "science",
    author: "编辑部",
    date: "2026-09-07",
    readCount: 6740,
    tags: ["行为", "心理"],
    sections: [
      {
        heading: "“成瘾”在医学上的含义",
        paragraphs: [
          "医学上的成瘾通常涉及强烈的渴求、失控、耐受与明显的功能损害，标准比日常用语严格得多。",
          "日常频繁并不自动等同于成瘾。",
        ],
      },
      {
        heading: "更常见的是习惯与情绪依赖",
        paragraphs: [
          "很多时候，人们描述的问题其实是习惯或用它来应对情绪，这与成瘾并不相同。",
          "识别背后的情绪需求，往往是更有帮助的第一步。",
        ],
      },
      {
        heading: "何时寻求帮助",
        paragraphs: [
          "如果它持续干扰工作、睡眠和人际关系，并让你难以自控，咨询专业人士是值得考虑的选择。",
        ],
      },
    ],
  },
  {
    id: "science-9",
    title: "不同年龄阶段的自慰认知与变化",
    summary:
      "从青春期到成年、再到中老年，身体与心态都在变化。了解这些变化，有助于用更包容的眼光看待自己。",
    cover:
      "https://readdy.ai/api/search-image?query=gentle%20abstract%20timeline%20of%20organic%20shapes%20transitioning%20through%20teal%20and%20warm%20sand%20tones%2C%20minimal%20life%20stages%20wellness%20illustration&width=800&height=600&seq=science-09&orientation=landscape",
    categoryId: "science",
    author: "编辑部",
    date: "2026-09-04",
    readCount: 3120,
    tags: ["年龄", "科普"],
    sections: [
      {
        heading: "每个阶段都有不同",
        paragraphs: [
          "青春期的好奇、成年期的节奏变化、中老年阶段的身体调整，都会带来不同的体验与关注点。",
          "没有哪个阶段是“不正常”的。",
        ],
      },
      {
        heading: "理解变化就是照顾自己",
        paragraphs: [
          "接纳身体随年龄的变化，能减少不必要的焦虑，让人更从容地与自己相处。",
        ],
      },
    ],
  },
  {
    id: "science-10",
    title: "性教育简史：人们如何理解自慰",
    summary:
      "今天我们对身体的许多认识，都是经过长期讨论与修正才形成的。回顾这段历史，能帮我们看得更清楚。",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20inspired%20minimal%20abstract%20illustration%20in%20muted%20teal%20and%20faded%20orange%2C%20editorial%20history%20of%20science%20wellness%20style&width=800&height=600&seq=science-10&orientation=landscape",
    categoryId: "science",
    author: "编辑部",
    date: "2026-09-01",
    readCount: 2870,
    tags: ["历史", "性教育"],
    sections: [
      {
        heading: "观念是被塑造的",
        paragraphs: [
          "不同时代对身体的看法差异巨大，许多曾经“理所当然”的结论后来都被修正。",
          "这提醒我们，今天的观念同样值得以开放和求证的心态对待。",
        ],
      },
      {
        heading: "科学教育的意义",
        paragraphs: [
          "全面、科学的性教育，能让人更了解身体、更懂得保护自己，也更少受到误导。",
        ],
      },
    ],
  },
];